export default __webpack_public_path__ + "static/media/promote.206ecd64.svg";